<template>
  <div v-if="user.data.id">
    <div class="audit__filter filter">
      <div class="filter__wrapper-left">
        <label class="filter__label" for="search">Filter</label>
        <div class="filter__input-wrapper">
          <el-input
            id="search"
            class="filter__input"
            placeholder="Search query"
            v-model="searchTerm"
            clearable
            @change="search"
            @input="searchInput"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @change="search"
            ></el-button>
          </el-input>
          <!-- <switch-checkbox
            class="checkbox"
            :text="$t('audit.exclude_guest_parking')"
            :onChange="toggleHideGuestParking"
            :checked="isHideGuestParking"
          /> -->
        </div>
      </div>
      <div class="filter__datepicker-container">
        <el-date-picker
          v-model="valueTimeRange"
          type="datetimerange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          align="center"
          format="dd.MM.yyyy HH:mm:ss"
          @change="selectedTime"
          @blur="selectedTime">
        </el-date-picker>
      </div>
      <div class="filter__perPage-container">
        <span v-show="(this.total / this.pathOptions.limit > 1 && valuePerPage === 10) || valuePerPage !== 10">
          <label class="filter__label" for="records">Records</label>
          <el-select
            v-model="valuePerPage"
            id="records"
            class="filter__perPage"
            placeholder="Select"
            @change="selectedPerPage"
          >
            <el-option
              v-for="perPage in optionsPerPage"
              :key="perPage.value"
              :label="perPage.label"
              :value="perPage.value">
            </el-option>
          </el-select>
        </span>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      styleClass="vgt-table striped"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'created_at'">{{props.row.created_at|formatDateWithWeekday}}</span>
        <span v-else-if="props.column.field == 'auditable_type'">
          <router-link :to="auditableRouterLink(props.row)" class="link">
            {{props.row.auditable_type.split('\\').pop()}}
          </router-link>
        </span>
        <span v-else-if="props.column.field == 'event'">
          {{$t('audit.event_' + props.row.event)}}
        </span>
        <span v-else-if="props.column.field == 'kiosk'">{{props.row.kiosk_partner}} - {{props.row.kiosk_description}}</span>
        <span v-else-if="props.column.field == 'account_emai'">{{props.row.account_email}}</span>
        <span v-else-if="props.column.field == 'changes'">
          <el-tabs v-if="auditId === props.row.id" v-model="activeTabName">
            <el-tab-pane :label="$t('audit.changes')" name="changes" class="changeset" :class="{expanded: auditId === props.row.id}" @click="auditableDetails(props.row)" v-html="props.row.event === 'deleted' ? auditableChanges(props.row.new_values, props.row.old_values) : auditableChanges(props.row.old_values, props.row.new_values)"></el-tab-pane>
            <el-tab-pane :label="$t('audit.was')" name="was" class="changeset" :class="{expanded: auditId === props.row.id}" @click="auditableDetails(props.row)" v-html="auditableParse(props.row.old_values)"></el-tab-pane>
            <el-tab-pane :label="$t('audit.now')" name="is" class="changeset" :class="{expanded: auditId === props.row.id}" @click="auditableDetails(props.row)" v-html="auditableParse(props.row.new_values)"></el-tab-pane>
          </el-tabs>
          <span v-else-if="auditId !== props.row.id" label="Now" name="is" class="changeset" :class="{expanded: auditId === props.row.id}" @click="auditableDetails(props.row)" v-html="props.row.event === 'deleted' ? auditableParse(props.row.old_values) : auditableParse(props.row.new_values)"></span>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
    <div class="audit__pagination-container">
      <el-pagination
        v-show="this.total / this.pathOptions.limit > 1"
        background
        layout="prev, pager, next"
        :page-size="this.pathOptions.limit"
        :total="this.total"
        @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { diff } from 'deep-object-diff';
  import { VueGoodTable } from 'vue-good-table';
  import 'vue-good-table/dist/vue-good-table.css';
  import SwitchCheckbox from 'common/SwitchCheckbox';

  export default {
    name: 'OldMainView',
    components: {
      VueGoodTable,
      SwitchCheckbox,
    },
    computed: {
      ...mapGetters({
        user: 'user/user/user',
        audit: 'audit/audit/audit',
      }),
    },
    mounted() {
      this.fetchAuditData();
    },
    data() {
      return {
        searchTerm: '',
        optionsPerPage: [
          {
            value: 10,
            label: 10,
          },
          {
            value: 25,
            label: 25,
          },
          {
            value: 50,
            label: 50,
          },
          {
            value: 100,
            label: 100,
          },
        ],
        valuePerPage: 10,
        valueTimeRange: [],
        columns: [],
        rows: [],
        total: 0,
        isHideGuestParking: false,
        pathOptions: {
          q: '',
          limit: 10,
          orderBy: '',
          ascending: 1,
          page: 1,
          byColumn: 0,
          dateFrom: '',
          dateTo: '',
          isHideGuestParking: 0,
        },
        auditId: null,
        activeTabName: 'changes',
      };
    },
    methods: {
      fetchAuditData() {
        if (this.user.data && this.user.data.selectedRole.id) {
          this.$store.dispatch('audit/audit/oldFetch', {
            user: this.user,
            options: {
              q: this.pathOptions.q,
              limit: this.pathOptions.limit,
              orderBy: this.pathOptions.orderBy,
              ascending: this.pathOptions.ascending,
              page: this.pathOptions.page,
              byColumn: this.pathOptions.byColumn,
              dateFrom: this.pathOptions.dateFrom,
              dateTo: this.pathOptions.dateTo,
              isHideGuestParking: this.pathOptions.isHideGuestParking,
            },
          }).then(() => {
            this.columns = [
              {
                label: this.$t('audit.updated_at'),
                field: 'created_at',
                type: 'date',
                dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                dateOutputFormat: 'dd.MM.yyyy HH:mm, EEEEEE',
                sortable: false,
                width: '250px',
              },
              {
                label: this.$t('audit.type'),
                field: 'auditable_type',
                sortable: false,
                width: '200px',
              },
              {
                label: this.$t('audit.event'),
                field: 'event',
                sortable: false,
                width: '250px',
              },
              {
                label: this.$t('audit.kiosk'),
                field: 'kiosk',
                sortable: false,
              },
              {
                label: this.$t('audit.account'),
                field: 'account_email',
                sortable: false,
              },
              {
                label: this.$t('audit.changes'),
                field: 'changes',
                sortable: false,
                width: '400px',
              },
            ];
            this.rows = this.audit.items;
            this.total = this.audit.total;
          });
        }
      },
      search() {
        this.pathOptions.q = this.searchTerm;
        this.fetchAuditData();
      },
      searchInput(value) {
        if (value.trim() === '') {
          this.search();
        }
      },
      selectedPerPage() {
        this.pathOptions.limit = this.valuePerPage;
        this.fetchAuditData();
      },
      selectedTime() {
        if (this.valueTimeRange && this.valueTimeRange.length > 0) {
          this.pathOptions.dateFrom = moment(this.valueTimeRange[0]).format('YYYY-MM-DD HH:mm:ss');
          this.pathOptions.dateTo = moment(this.valueTimeRange[1]).format('YYYY-MM-DD HH:mm:ss');
        } else {
          this.pathOptions.dateFrom = '';
          this.pathOptions.dateTo = '';
        }
        this.fetchAuditData();
      },
      changePage(value) {
        this.pathOptions.page = value;
        this.fetchAuditData();
      },
      auditableRouterLink(row) {
        let route = '';
        let id = row.auditable_id;

        switch (row.auditable_type) {
          case 'App\\Models\\Account':
            route = '';
            break;
          case 'App\\Models\\Vehicle':
            route = 'user';
            if (row.event === 'deleted') {
              id = row.old_values.user_id;
            } else {
              id = row.new_values.user_id;
            }
            break;
          case 'App\\Models\\PartnerProduct':
            route = 'tenant';
            if (row.event === 'deleted') {
              id = row.old_values.partner_id;
            } else {
              id = row.new_values.partner_id;
            }
            break;
          case 'App\\Models\\Partner':
            if (!row.old_values.parent_partner_id &&
                !row.new_values.parent_partner_id) {
              route = 'landlord';
              if (row.event === 'deleted') {
                id = row.old_values.id;
              } else {
                id = row.new_values.id;
              }
            } else {
              route = 'tenant';
              if (row.event === 'deleted') {
                id = row.old_values.id;
              } else {
                id = row.new_values.id;
              }
            }
            break;
          default:
            route = row.auditable_type.split('\\').pop().toLowerCase();
        }
        const to = {
          name: route,
          params: {
            id,
          },
        };
        to.query = {
          show: 'all',
        };
        return to;
      },
      auditableChanges(oldValues, newValues) {
        const diffResult = diff(oldValues, newValues);
        return this.auditableParse(diffResult);
      },
      auditableParse(values) {
        return Object.keys(values)
          .map((key) => {
            let value = values[key];
            if (value instanceof Object && value.date) {
              value = moment(value.date).format('DD.MM.YYYY HH:mm, dd');
            }
            return `${key}: ${value}`;
          })
          .join('<br>');
      },
      auditableDetails(row) {
        if (this.auditId === row.id) {
          this.auditId = null;
        } else {
          this.auditId = row.id;
        }
      },
      toggleHideGuestParking(isChecked) {
        if (isChecked === true) {
          this.pathOptions.isHideGuestParking = 1;
        } else {
          this.pathOptions.isHideGuestParking = 0;
        }
        this.isHideGuestParking = isChecked;
        this.fetchAuditData();
      },
    },
    filters: {
      formatDateWithWeekday(momentDate) {
        return momentDate == null ? '' : moment(momentDate).format('DD.MM.YYYY HH:mm, dd');
      },
    },
  };
</script>

<style lang="scss">
  @import '~styles/app.scss';
  .vgt-global-search {
    display: none;
  }

  .vgt-table {
    thead {
      th {
        background: transparent;
      }
    }
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: var(--brand-orange);
  }
</style>
<style lang="scss" scoped>
  .changeset {
    cursor: pointer;
    word-break: break-all;
    max-height: 55px;
    overflow: hidden;
    display: inline-block;

    &.expanded {
      max-height: initial;
      max-width: initial;
    }
  }

  .audit {
    &__filter {
      margin-bottom: 20px;
    }

    &__pagination-container {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }

  .filter {
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 1200px) {
      flex-direction: column;
    }

    &__label {
      display: block;
      margin-bottom: 2px;
      cursor: pointer;
    }

    &__input {
      width: 250px;

      @media screen and (max-width: 1200px) {
        width: 100%;
      }

      &-wrapper {
        display: flex;

        @media screen and (max-width: 1700px) {
          flex-direction: column;
        }

        @media screen and (max-width: 1200px) {
          flex-direction: row;
        }
      }
    }

    &__datepicker-container {
      align-self: flex-end;
      margin-right: 400px;

      @media screen and (max-width: 1700px) {
        align-self: flex-start;
        margin: 18px 0 0 0;
      }

      @media screen and (max-width: 1200px) {
        margin: 25px 0 0 0;
      }
    }

    &__perPage-container {
      width: 80px;

      @media screen and (max-width: 1200px) {
        align-self: flex-end;
        margin-top: -58px;
      }
    }
  }

  .checkbox {
    align-self: center;
    margin-left: 20px;
    height: 20px;

    @media screen and (max-width: 1700px) {
      margin: 20px 0 0 0;
    }

    @media screen and (max-width: 1200px) {
      margin: 0 0 0 20px;
      white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/audit/OldMainView.vue